import React from 'react';

import { Body, Caption } from '@depop/web-thrift-ui/Typography';
import clsx from 'clsx';

import styles from './styles.module.css';

export type SuggestionOptionClickPayload<TValue = string> = {
  event: React.MouseEvent<HTMLButtonElement>;
  value: TValue;
};

type Props<TValue> = {
  isSelected: boolean;
  isRecommended?: boolean;
  ariaPressed?: boolean;
  topLabel?: string;
  displayLabel: string;
  value: TValue;
  onClick: (payload: SuggestionOptionClickPayload<TValue>) => void;
};

export function SuggestionOptionButton<TValue = string>({
  isSelected,
  isRecommended,
  ariaPressed,
  topLabel,
  displayLabel,
  value,
  onClick,
}: Props<TValue>) {
  return (
    <button
      aria-pressed={ariaPressed}
      className={clsx(styles.button, {
        [styles.buttonSelected]: isSelected,
        [styles.buttonRecommended]: isRecommended,
        [styles.buttonSelectedRecommended]: isSelected && isRecommended,
      })}
      onClick={(event) => onClick({ event, value })}
      type="button"
    >
      <Caption variant="lg-regular" as="span">
        {topLabel}
      </Caption>
      <Body variant="sm-bold" as="span">
        {displayLabel}
      </Body>
    </button>
  );
}
